import { all } from 'redux-saga/effects';

import * as events from './modules/events';
import * as faq from './modules/faq';
import * as registration from './modules/registration';
import * as rules from './modules/rules';
import * as windowModule from './modules/window';

export default function*() {
  yield all([
    events.saga(),
    windowModule.saga(),
    registration.saga(),
    faq.saga(),
    rules.saga()
  ]);
}



// WEBPACK FOOTER //
// ./src/store/rootSaga.ts